import React from 'react';
import { observer } from 'mobx-react';
import Modal from '../Modal/Modal';
import { productPopupStore } from '@stores/main';
import styles from './ProductPopup.module.scss';

const ProductPopup: React.FC = observer(() => {
  const handleBuyNow = () => {
    productPopupStore.hide();
    window.location.href = process.env.REACT_APP_SUBSCRIPTION_PAGE_URL + '?redirectUrl=' + window.location.href;
  };

  return (
    <Modal
      isOpen={productPopupStore.isVisible}
      onClose={() => productPopupStore.hide()}
    >
      <section className={styles.popup}>
        <div className={`${styles["popup-close"]} fs-white cursor-pointer`} onClick={() => productPopupStore.hide()}>
          <img src={`${process.env.PUBLIC_URL}/images/icons/close-icon.svg`} alt="Close" />
        </div>
        <div className={styles["popup-body"]}>
          <div className={styles["popup-logo"]}>
            <img src={`${process.env.PUBLIC_URL}/images/logos/popup-logo.svg`} alt="Logo" />
          </div>
          <div className={`${styles["popup-heading"]} fw-600 fs-white`}>
            {/* {productPopupStore.message} */}
            It seems you don't have an active monthly subscription. Want to purchase one?
            <br />
            Extra discount applies to non-trial plans.
          </div>
          <div className={`${styles["continue-btn"]} fs-white cursor-pointer`} onClick={handleBuyNow}>
            Buy Now
          </div>
          <div className={`${styles["cancel-btn"]} fs-gray color-lightgray cursor-pointer`} onClick={() => productPopupStore.hide()}>
            Cancel
          </div>
        </div>
      </section>
    </Modal>
  );
});

export default ProductPopup; 